<template>
<div class="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    Redirecting...
  </div>
</div>
</template>

<script setup>
window.location.href = 'https://forms.monday.com/forms/32201563efd39abf884cc2dbc60bccbb?r=euc1'
</script>
